/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Profile } from "App/IOC/Services";

export default {
    Get: Profile.Get,
    Update: Profile.Update,
    ChangePassword: Profile.ChangePassword,
    TotpStatus: Profile.TotpStatus,
    TotpBegin: Profile.TotpBegin,
    TotpEnable: Profile.TotpEnable,
    TotpDisable: Profile.TotpDisable,
    TotpRecovery: Profile.TotpRecovery,
    Sessions: Profile.Sessions,
    RevokeSession: Profile.RevokeSession
};
